<template>
  <div class="nav-wrapper">
    <v-btn
      v-if="backward"
      class="nav-item nav-arrow backward grey--text text--darken-1"
      flat
      round
      @click="goBackward()"
    >
      <v-icon x-large>
        chevron_left
      </v-icon>
    </v-btn>
    <div
      v-for="(link, index) in linkObjects"
      :key="index"
    >
      <span
        class="nav-item ml-2 mr-1"
        :class="{
          inactive: link.active === false,
          'pseudo-anchor--inverted':
            link.active !== false && index !== linkObjects.length - 1,
        }"
        data-cy="breadcrumb"
        :style="{cursor: active ? 'pointer' : 'default'}"
        :disabled="index === linkObjects.length - 1"
        @click="active ? goTo(link) : null"
        @click.middle.exact="active ? newTab(link) : null"
      >
        {{
          $te(getLinkLabel(link)) ? $t(getLinkLabel(link)) : getLinkLabel(link)
        }}</span>
      <span
        v-if="index !== linkObjects.length - 1"
        class="grey--text"
      >
        <v-icon
          v-if="icon"
          class="nav-separator"
        >{{ separator }}</v-icon>
        <span
          v-if="!icon"
          class="nav-separator"
        >{{ separator }}</span>
      </span>
    </div>
    <v-btn
      v-if="forward"
      class="nav-item last nav-arrow forward grey--text text--darken-1"
      flat
      round
      @click="goForward()"
    >
      <v-icon x-large>
        chevron_right
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  props: {
    /* Array of route names or Objects with a .path/.name property.
     *
     * Can also have .active = false property to deactivate their link.
     */
    links: {
      type: Array[String | Object],
      required: true,
    },
    /* Whether to use icon as separator */
    icon: {
      type: Boolean,
      default: false,
    },
    separator: {
      type: String,
      default: '/',
    },
    backward: {
      type: Boolean,
      default: true,
    },
    forward: {
      type: Boolean,
      default: false,
    },
    /* Whether the links are enabled and route when clicked */
    active: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      routeItems: [this.$store.getters.previousRoute, this.$route],
    };
  },
  computed: {
    /**
     * Since links can be just strings, convert them to objects here.
     */
    linkObjects() {
      let linkObjects = [];
      for (var i = 0; i < this.links.length; i++) {
        let link = this.links[i];
        if (typeof link === 'string') {
          link = {name: link};
        }
        linkObjects.push(link);
      }
      return linkObjects;
    },
  },
  methods: {
    getLinkLabel(link) {
      if (link.label !== undefined) {
        return link.label;
      }
      return link.name;
    },
    hasHistory() {
      return this.$store.state.common.routeHistory.length > 1;
    },
    goBackward() {
      this.$router.go(-1);
    },
    goForward() {
      this.$router.go(1);
    },
    linkToRoute(link) {
      let route = {};
      if (link.route) {
        route = link.route;
      } else if (link.path) {
        route.path = link.path;
      } else if (link.name) {
        route.name = link.name;
      }
      return route;
    },
    /**
     * Allow routing via different attributes.
     *
     * The following fields can be used (in preferred order):
     *
     *   - link.route: A $route object with e.g. .name or .path, .params.
     *   - link.path: A $route.path
     *   - link.name: A $route.name
     */
    goTo(link) {
      const route = this.linkToRoute(link);
      if (this.active) {
        // Each route can also be deactivated individually, check that.
        if (route.active !== undefined) {
          if (!route.active) {
            return;
          }
        }
        this.$router.push(route);
      }
    },
    newTab(link) {
      const route = this.linkToRoute(link);
      const resolved = this.$router.resolve(route);
      window.open(resolved.href, '_blank');
    },
  },
};
</script>

<style scoped>
.nav-wrapper {
  height: 24px;
  margin-left: -8px;
  margin-top: -4px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
}
@media (min-width: 1264px) {
  .nav-wrapper {
    height: auto;
  }
}

.nav-item {
  font-size: 16px;
  cursor: pointer;
  color: #2196f3;
}
@media (min-width: 1264px) {
  .nav-item {
    font-size: 20px;
  }
}
.nav-item.inactive {
  color: #919191;
}
.nav-item:last-child {
  color: #919191;
}
.nav-item.first {
  margin-right: auto;
}
.nav-item.last {
  margin-left: auto;
}

.nav-separator {
  font-size: 16px;
}
@media (min-width: 1264px) {
  .nav-separator {
    font-size: 20px;
  }
}

.nav-arrow {
  font-size: 16px;
  user-select: none;
  margin: 0;
  min-width: 36px;
  max-width: 36px;
}
@media (min-width: 1264px) {
  .nav-arrow {
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue